import { AddSelectOption } from "@/app/components/AddSelectOption";
import { CustomField } from "@/app/components/form-fields/atoms";
import { MultiLevelSelect } from "@/app/components/form-fields/select/MultiLevelSelect";
import { MultiValues } from "@/app/components/MultiValues";
import {
  Entity,
  ISelectFieldMulti,
  ISelectFieldOption,
} from "@/app/fields/types";

export const MultiValueSubForm = <T extends Entity>({
  field,
  options,
  isDisabled,
  onAddOption,
}: {
  field: ISelectFieldMulti<T>;
  options: ISelectFieldOption[];
  isDisabled?: boolean;
  onAddOption: (option: ISelectFieldOption) => void;
}) => {
  return (
    <CustomField
      field={field}
      isDisabled={isDisabled}
      addOption={
        field.is_dynamic && (
          <AddSelectOption
            fieldName={String(field.field)}
            fieldLabel={field.label}
            onAddSuccess={onAddOption}
            groups={
              options
                .map(({ group }) => group)
                .filter((group) => group !== null)
                .filter(
                  (group, index, arr) => arr.indexOf(group) === index
                ) as string[]
            }
          />
        )
      }
      render={({
        field: { onChange, name, value: values = [], onBlur },
        fieldState: { invalid },
      }) => (
        <>
          <MultiLevelSelect
            options={options.filter(({ value }) => !values.includes(value))}
            isInvalid={invalid}
            label="Select values..."
            isDisabled={isDisabled}
            onBlur={onBlur}
            onOptionClick={({ value }) => {
              onChange([...values, value]);
            }}
          />
          {!!values.length && (
            <div className="my-2">
              <MultiValues
                options={options.filter(({ value }) => values.includes(value))}
                onRemove={
                  !isDisabled
                    ? (value) =>
                        onChange(values.filter((v: string) => v !== value))
                    : undefined
                }
                size="sm"
              />
            </div>
          )}
          <input
            id={`form-field-${name}`}
            className="hidden"
            value={values}
            name={name}
            required={field.is_required}
            disabled={isDisabled}
            onChange={() => {}}
          />
        </>
      )}
    />
  );
};
